import React from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import UserProfile from "../../services/user_profile.service";
import * as Yup from "yup";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";
import { useEffect } from "react";
import CommonService from "../../services/common.service";
import PreviewImage from "../../Component/PreviewImage";
import ToastComponent from "../Common/TaostComponent";
import Select from "react-select";
import { Col, Row } from "react-bootstrap";

const ChangePassword = () => {
  const [result, setResult] = useState({});

  useEffect(() => {
    CommonService.getUpdateProfileData().then((res) => {
      if (res.status === 200) {
        setResult(res.data);
      }
    });
  }, []);

  const navigate = useNavigate();
  const initialValues = {
    email: result?.email || "",
    confirm_password: "",
    password: "",
  };
  const validationSchema = Yup.object({
    password: Yup.string()
      .required("Email required.")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        `Must be a minimum of 8 characters, contain at
          least a number, an uppercase & lowercase
          alphabet and a special character (ex:
          Hello@123)`
      ),
    confirm_password: Yup.string()
      .required("Confirm Email required.")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
  const onSubmit = (formValue, values) => {
    CommonService.changePassword(formValue).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, "success");
        navigate("/my-games");
      }
    });
  };

  return (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>Change Password</h2>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {({ errors, handleChange, values, touched, setFieldValue }) => (
              <Form>
                <div>
                  <div className="whitebox">
                    <div className="playerprofile-section">
                      <div className="loginform">
                        <Row>
                          <Col>
                            <div className="form-group mb-3">
                              <label
                                htmlFor="Password"
                                className="pb-2 fw-bold"
                              >
                                Email
                              </label>
                              <Field
                                name="email"
                                type="email"
                                className="form-control"
                                placeholder="email*"
                                autoComplete="new-password"
                                disabled
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="form-group mb-3">
                              <label
                                htmlFor="Password"
                                className="pb-2 fw-bold"
                              >
                                Password*
                              </label>
                              <Field
                                name="password"
                                type="password"
                                className="form-control"
                                placeholder="Password*"
                                autoComplete="new-password"
                              />

                              {touched.password && errors.password && (
                                <span className="help-inline error">
                                  {errors.password}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col>
                            <div className="form-group mb-3">
                              <label
                                htmlFor="fantasy_hub"
                                className="pb-2 fw-bold"
                              >
                                Confirm Password*
                              </label>
                              <Field
                                name="confirm_password"
                                type="password"
                                className="form-control"
                                placeholder="Confirm Password*"
                              />
                              {touched.confirm_password &&
                                errors.confirm_password && (
                                  <span className="help-inline error">
                                    {errors.confirm_password}
                                  </span>
                                )}
                            </div>
                          </Col>
                        </Row>
                        <div className="text-center">
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
